import React, {useEffect, useState} from 'react';
import {collection, getDocs,} from "firebase/firestore";
import {Button, Select} from "@headlessui/react";
import {
    ArrowPathIcon, DocumentCurrencyDollarIcon, PlusIcon,
    TrashIcon,
} from "@heroicons/react/24/outline";
import {db} from "../firebase/firebase";
import {useAuth} from "../contexts/authContext";
import {useDarkMode} from "../contexts/darkModeContext";
import { ReactComponent as ExcelSVG } from "../excel-file-type.svg"
import Loading from "./Widgets/Loading";
import OrderSearchInput from "./Orders/OrderSearchInput";
import {useNotification} from "./Notifications/NotificationProvider";
import SoilCard from "./SoilTests/SoilCard";



const secondaryNavigation = [
  { name: 'Dashboard', href: '#', current: true },
  { name: 'Activity', href: '#', current: false },
  { name: 'Settings', href: '#', current: false },
  { name: 'Collaborators', href: '#', current: false },
  { name: 'Notifications', href: '#', current: false },
]
const stats = [
  { name: 'Number of Orders', value: '405' },
  { name: 'Active Orders', value: '3.65', unit: 'mins' },
  { name: 'Pending Orders', value: '3' },
  { name: 'Planned Orders', value: '98.5%' },
]
const statuses = { Completed: 'text-green-400 bg-green-400/10', Error: 'text-rose-400 bg-rose-400/10' }
const activityItems = [
  {
    user: {
      name: 'Michael Foster',
      imageUrl:
        'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    },
    commit: '2d89f0c8',
    branch: 'main',
    status: 'Completed',
    duration: '25s',
    date: '45 minutes ago',
    dateTime: '2023-01-23T11:00',
  },
  // More items...
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}



const Soil = () => {
    const { currentUser } = useAuth();
    
    
    const [alertsOn] = useState(() => {
        const storedSettings = localStorage.getItem('alertsOn');
        return storedSettings ? JSON.parse(storedSettings).alertsOn : false; // Default to false if null
    });

    const [status, setStatus] = useState("A");

    const { darkMode } = useDarkMode();
    const { triggerNotification } = useNotification();
    
    const [results, setResults] = useState([]);
    
    const [filteredResults, setFilteredResults] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    // Handle dropdown change
    const handleStatusChange = (e) => {
        setStatus(e.target.value);
    };

    useEffect(() => {

        const fetchSoilResults = async () => {
            if (currentUser) {
                try {
                    const storedActiveData = localStorage.getItem(`soilResults_${currentUser.uid}`);
                    if (storedActiveData) {
                        const customersData = JSON.parse(storedActiveData);
                        customersData.sort((a, b) => new Date(b.submittedTime) - new Date(a.submittedTime));
                        setResults(customersData);
                        setFilteredResults(customersData);
                    } else {
                        const clientsCollectionRef = collection(db, `Customers/${currentUser.uid}/clients`);
                        const clientsSnapshot = await getDocs(clientsCollectionRef);
                        let allActiveData = [];

                        for (const clientDoc of clientsSnapshot.docs) {
                            const clientId = clientDoc.id;

                            const pendingCollectionRef = collection(db, `Customers/${currentUser.uid}/clients/${clientId}/SoilTests`);
                            const activeSnapshot = await getDocs(pendingCollectionRef);

                            activeSnapshot.forEach((pendingDoc) => {
                                allActiveData.push({
                                    clientId,
                                    id: pendingDoc.id, // Add the document ID
                                    ...pendingDoc.data(),
                                });
                            });
                        }


                        if (!allActiveData.empty) {
                            allActiveData.sort((a, b) => new Date(b.submittedTime) - new Date(a.submittedTime));
                            setResults(allActiveData);
                            setFilteredResults(allActiveData);
                            localStorage.setItem(`soilResults_${currentUser.uid}`, JSON.stringify(allActiveData));
                        } else {
                            setResults([]);
                            setFilteredResults([]);
                            console.log('Active Order document not found');
                        }

                    }
                } catch (error) {
                    console.error('Error fetching orders data:', error);
                }
            }
        }

       fetchSoilResults();
    }, [currentUser]);



    //
    const [updating, setUpdating] = useState(false);

    const onUpdate = async () => {
        console.log("OnUpdate Running");
        
        setUpdating(true);
        const startTime = Date.now();
        
        // Active
        try {
            const clientsCollectionRef = collection(db, `Customers/${currentUser.uid}/clients`);
            const clientsSnapshot = await getDocs(clientsCollectionRef);
            let allActiveData = [];

            // Create an array of promises for fetching planned collections
            const activePromises = clientsSnapshot.docs.map(async (clientDoc) => {
                const clientId = clientDoc.id;

                const pendingCollectionRef = collection(db, `Customers/${currentUser.uid}/clients/${clientId}/SoilTests`);
                const activeSnapshot = await getDocs(pendingCollectionRef);

                activeSnapshot.forEach((pendingDoc) => {
                    allActiveData.push({
                        clientId,
                        id: pendingDoc.id, // Add the document ID
                        ...pendingDoc.data(),
                    });
                });
            });

            // Run all planned fetches in parallel
            await Promise.all(activePromises);

            if (!allActiveData.empty) {
                allActiveData.sort((a, b) => new Date(b.submittedTime) - new Date(a.submittedTime));
                setResults(allActiveData);
                setFilteredResults(allActiveData);
                localStorage.setItem(`soilResults_${currentUser.uid}`, JSON.stringify(allActiveData));
            } else {
                setResults([]);
                setFilteredResults([]);
                localStorage.setItem(`soilResults_${currentUser.uid}`, JSON.stringify([]));
                console.log('Active Order document not found');
            }

        } catch (error) {
            console.error('Error fetching planned orders data:', error);
        }

        const endTime = Date.now();
        const timeElapsed = (endTime - startTime) /1000;
        setUpdating(false);
        triggerNotification("ordersUpdated");
        
        if (alertsOn) {
            alert(`Orders Updated in ${timeElapsed} secs`);
        }
    };
    

    const handleActiveSearch = (query) => {
        setSearchQuery(query);
        const filtered = results.filter((order) =>
            order.customerName.toLowerCase().includes(query.toLowerCase()) ||
            order.customerCode.toLowerCase().includes(query.toLowerCase()) ||
            order.orderERP.toString().includes(query.toLowerCase())
        );
        setFilteredResults(filtered);
    }

    
    



    const [itemsPerPage, setItemsPerPage] = useState(25);
    const [currentPage, setCurrentPage] = useState(1);
    
    const totalPages = Math.ceil(filteredResults.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentResults = filteredResults.slice(startIndex, startIndex + itemsPerPage);

    

    
   
    

   
   
    return (
            <div className={`${darkMode ? 'bg-darkBgColor' : 'bg-bgColor'} flex h-[calc(100dvh-4rem)] w-full transition-all duration-500 ease-in-out`}>
                
                {updating && (
                    <Loading/>
                )}
                
                
                <div className={`z-20 ${darkMode ? 'bg-darkMainColor border-neutral-700 text-white' : 'bg-white text-black'} m-3 w-full rounded-lg border`}>
                    
                    <main>
                        
                        
                        <header>
                            {/* Secondary navigation */}
                            <nav className="flex overflow-x-auto border-b border-white/10 py-4">
                                <ul
                                    className="flex min-w-full flex-none gap-x-6 px-4 text-sm/6 font-semibold text-gray-400 sm:px-6 lg:px-8"
                                >
                                    {secondaryNavigation.map((item) => (
                                        <li key={item.name}>
                                            <a href={item.href} className={item.current ? 'text-green-600' : ''}>
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                            
                            {/* Heading */}
                            <div className={`flex flex-col items-start justify-between gap-x-8 ${darkMode ? ' bg-gray-700/10' : 'bg-neutral-300/50'} px-4 py-2 sm:flex-row sm:items-center sm:px-6 lg:px-8`}>
                                <div>
                                    <div className="flex items-center gap-x-3">
                                        <div className="flex-none rounded-full bg-green-600/25 p-1 text-green-600">
                                            <div className="size-2 rounded-full bg-current"/>
                                        </div>
                                        <h1 className="flex gap-x-3 text-base/7">
                                            <span className="font-semibold">Current Orders</span>
                                            <span className="text-gray-600">/</span>
                                            <span className="font-semibold">Active Orders</span>
                                        </h1>
                                    </div>
                                    <p className="mt-2 text-xs/6 text-gray-500">Orders Placed Through Your Order Form</p>
                                </div>
                                <div className="order-first flex-none rounded-full bg-indigo-400/10 px-2 py-1 text-xs font-medium text-indigo-400 ring-1 ring-indigo-400/30 ring-inset sm:order-none">
                                    Production
                                </div>
                            </div>
                            
                            {/* Stats */}
                            <div className={`grid grid-cols-1 ${darkMode ? ' bg-gray-700/10' : 'bg-neutral-300/50'} sm:grid-cols-2 lg:grid-cols-4`}>
                                {stats.map((stat, statIdx) => (
                                    <div
                                        key={stat.name}
                                        className={classNames(
                                            statIdx % 2 === 1 ? 'sm:border-l' : statIdx === 2 ? 'lg:border-l' : '',
                                            'border-t border-white/5 px-4 py-2 sm:px-6 lg:px-8',
                                        )}
                                    >
                                        <p className="text-sm/6 font-medium text-gray-500">{stat.name}</p>
                                        <p className="flex items-baseline gap-x-2">
                                            <span
                                                className="text-4xl font-semibold tracking-tight">{stat.value}</span>
                                            {stat.unit ?
                                                <span className="text-sm text-gray-400">{stat.unit}</span> : null}
                                        </p>
                                    </div>
                                ))}
                            </div>
                            
                        </header>
                        
                        {/* Activity list */}
                        <div className="border-t border-white/10 pt-4">
                            <h2 className="px-4 text-base/7 font-semibold sm:px-6 lg:px-8">Latest activity</h2>
                            
                            <table className="mt-3 w-full text-left whitespace-nowrap">
                                <colgroup>
                                    <col className="w-full sm:w-4/12"/>
                                    <col className="lg:w-4/12"/>
                                    <col className="lg:w-2/12"/>
                                    <col className="lg:w-1/12"/>
                                    <col className="lg:w-1/12"/>
                                </colgroup>
                                <thead className="border-b border-white/10 text-sm/6 text-white">
                                <tr>
                                    <th scope="col" className="py-2 pr-8 pl-4 font-semibold sm:pl-6 lg:pl-8">
                                        User
                                    </th>
                                    <th scope="col" className="hidden py-2 pr-8 pl-0 font-semibold sm:table-cell">
                                        Commit
                                    </th>
                                    <th scope="col"
                                        className="py-2 pr-4 pl-0 text-right font-semibold sm:pr-8 sm:text-left lg:pr-20">
                                        Status
                                    </th>
                                    <th scope="col"
                                        className="hidden py-2 pr-8 pl-0 font-semibold md:table-cell lg:pr-20">
                                        Duration
                                    </th>
                                    <th
                                        scope="col"
                                        className="hidden py-2 pr-4 pl-0 text-right font-semibold sm:table-cell sm:pr-6 lg:pr-8"
                                    >
                                        Deployed at
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-white/5">
                                {activityItems.map((item) => (
                                    <tr key={item.commit}>
                                        <td className="py-4 pr-8 pl-4 sm:pl-6 lg:pl-8">
                                            <div className="flex items-center gap-x-4">
                                                <img alt="" src={item.user.imageUrl}
                                                     className="size-8 rounded-full bg-gray-800"/>
                                                <div
                                                    className="truncate text-sm/6 font-medium text-white">{item.user.name}</div>
                                            </div>
                                        </td>
                                        <td className="hidden py-4 pr-4 pl-0 sm:table-cell sm:pr-8">
                                            <div className="flex gap-x-3">
                                                <div className="font-mono text-sm/6 text-gray-400">{item.commit}</div>
                                                <span
                                                    className="inline-flex items-center rounded-md bg-gray-400/10 px-2 py-1 text-xs font-medium text-gray-400 ring-1 ring-gray-400/20 ring-inset">
                            {item.branch}
                          </span>
                                            </div>
                                        </td>
                                        <td className="py-4 pr-4 pl-0 text-sm/6 sm:pr-8 lg:pr-20">
                                            <div className="flex items-center justify-end gap-x-2 sm:justify-start">
                                                <time dateTime={item.dateTime} className="text-gray-400 sm:hidden">
                                                    {item.date}
                                                </time>
                                                <div
                                                    className={classNames(statuses[item.status], 'flex-none rounded-full p-1')}>
                                                    <div className="size-1.5 rounded-full bg-current"/>
                                                </div>
                                                <div className="hidden text-white sm:block">{item.status}</div>
                                            </div>
                                        </td>
                                        <td className="hidden py-4 pr-8 pl-0 text-sm/6 text-gray-400 md:table-cell lg:pr-20">
                                            {item.duration}
                                        </td>
                                        <td className="hidden py-4 pr-4 pl-0 text-right text-sm/6 text-gray-400 sm:table-cell sm:pr-6 lg:pr-8">
                                            <time dateTime={item.dateTime}>{item.date}</time>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            
                            
                            
                        </div>
                    </main>
                
                </div>
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                <div className="hidden z-20 animate-fadeIn flex flex-col w-full max-w-[calc(100%-6rem)] mt-3 mb-3 mr-3">
                    
                    {/*Customers Header*/}
                    <div className="w-full h-fit flex mb-3">
                        
                        <div
                            className={`text-2xl w-1/4 ${darkMode ? 'text-white' : 'text-black'} mr-5 flex flex-row tracking-widest`}>Soil
                            Tests
                            {/*Buttons Delete*/}
                            <div
                                className={`flex flex-col items-center ml-3 mt-auto mb-auto ${updating ? 'animate-pulse' : ''}`}>
                                <Button
                                    className={`rounded-full ${darkMode ? 'bg-darkMainColor text-gray-500' : 'bg-white text-gray-700'} p-1 hover:scale-105 hover:rotate-12 mt-auto mb-auto h-7 w-7 items-center justify-center align-middle ${updating ? 'animate-spin' : ''}`}
                                    onClick={onUpdate}
                                >
                                    <ArrowPathIcon className="m-auto"/>
                                </Button>
                            </div>
                        </div>
                        
                        <div
                            className={`text-xl w-2/3 mr-auto border ${darkMode ? 'bg-darkMainColor border-neutral-700 text-white' : 'bg-white border text-black'} flex rounded-md border drop-shadow shadow-gray-900`}>
                            
                            <div className="flex w-full flex-row items-center align-middle justify-center h-full">
                                <div className="font-semibold text-sm mr-1 line-clamp-1">Active:</div>
                            </div>
                            
                            <div className="flex w-full flex-row items-center align-middle justify-center h-full">
                                <div className="font-semibold text-sm mr-1 line-clamp-1">Pending:</div>
                            </div>
                            
                            <div className="flex w-full flex-row items-center align-middle justify-center h-full">
                                <div className="font-semibold text-sm mr-1 line-clamp-1">Planned:</div>
                            </div>
                        
                        </div>
                        
                        <div className="w-1/6 flex items-center text-black ml-1.5">
                            <Button
                                className="bg-green-600 h-fit w-full hover:scale-105 tracking-widest hover:bg-opacity-50 rounded-md py-1 px-6 text-white text-sm flex flex-row align-middle justify-center items-center"
                                // onClick={downloadMapping}
                                // disabled={true}
                            >
                                <ExcelSVG className={`w-8 h-6 hover:stroke-green-600 stroke-white fill-white`}/>
                                <div className="w-full line-clamp-1">Download Excel</div>
                            </Button>
                        </div>
                    
                    
                    </div>
                    
                    {/*Search bar row*/}
                    <div className={`w-full h-fit flex mb-3 ${darkMode ? 'text-white' : 'text-black'}`}>
                        
                        {/*Search Bar*/}
                        <div className="w-1/2 mr-1.5 h-fit text-sm">
                            {/*<div className="text-sm mb-1">Customer</div>*/}
                            
                            <div
                                className={`border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} w-full rounded-md flex items-center justify-center hover:scale-y-105 drop-shadow shadow-gray-900`}>
                                <OrderSearchInput
                                    status={status}
                                    searchQuery={searchQuery}
                                    setSearchQuery={setSearchQuery}
                                    onSearch={
                                        status === "A" ? handleActiveSearch :
                                            () => {
                                            }
                                    }
                                    darkMode={darkMode}
                                />
                            </div>
                        
                        </div>
                        
                        {/*Status*/}
                        <div className="w-1/6 mr-1.5 ml-1.5 h-full text-sm">
                            
                            <div className="flex flex-col w-full mr-3 h-full">
                                {/*<div className="text-sm mb-1">Status</div>*/}
                                <Select
                                    className={`border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} focus:outline-none h-full drop-shadow shadow-gray-900 py-1 px-4 rounded-md hover:scale-y-105`}
                                    value={status}
                                    onChange={handleStatusChange}
                                >
                                    <option value="A">Active</option>
                                    <option value="P">Pending</option>
                                    <option value="Planned">Planned</option>
                                    {/*<option value="All">All Orders</option>*/}
                                </Select>
                            </div>
                        
                        </div>
                        
                        {/*Industry*/}
                        <div className="w-1/6 mr-1.5 ml-1.5 h-full text-sm">
                            
                            <div className="flex flex-col w-full mr-3 h-full">
                                {/*<div className="text-sm mb-1">Industry</div>*/}
                                
                                <Select
                                    className={`border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} focus:outline-none h-full drop-shadow shadow-gray-900 py-1 px-4 rounded-md hover:scale-y-105`}
                                    // onChange={filtering}
                                >
                                    <option value="">Select Industry...</option>
                                    <option value="BOTANICAL">Botanical Garden</option>
                                    <option value="DISTRIB">Product Distributor</option>
                                    <option value="EMPLOYEE">PFC-EMPLOYEE</option>
                                    <option value="FARM">Agriculture - Farm</option>
                                        <option value="GOLF">Golf Course</option>
                                        <option value="GOVERNMENT">Government Entity</option>
                                        <option value="INDUSTRIAL">Industrial</option>
                                        <option value="LAWNTREE">Lawn Care & Tree Care</option>
                                        <option value="MRSALE">One Time Purchase Expected</option>
                                        <option value="MUNICIPAL">Municipal/ School</option>
                                        <option value="Non-Profit">Non-Profit Account</option>
                                        <option value="OTHER">Other</option>
                                        <option value="SPORTFLD">Sportsfield</option>
                                    </Select>
                                </div>
        
                            </div>
        
                            {/*Pricing Type*/}
                            <div className="w-1/6 ml-1.5 h-full text-sm">
        
                                <div className="flex flex-col w-full mr-3 h-full">
                                    {/*<div className="text-sm mb-1">Pricing Type</div>*/}
                                    <Select
                                        className={`border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} focus:outline-none h-full drop-shadow shadow-gray-900 py-1 px-4 rounded-md hover:scale-y-105`}
                                        // onChange={filteringPrice}
                                    >
                                        <option value="">Select Price Type...</option>
                                        <option value="AG">Agriculture</option>
                                        <option value="DIST1">Distributor NE/INTL</option>
                                        <option value="DIST2">Distributor SE/CAN</option>
                                        <option value="NE">Northeast</option>
                                        <option value="SE">Southeast</option>
                                    </Select>
                                </div>
        
                            </div>
        
        
                        </div>
        
                        {/*Orders Body*/}
                        <div className="w-full h-full rounded-md">
        
                            {/*Orders Maps*/}
                            <div className="w-full flex h-full flex-col">
        
        
                                <div className={`w-full h-full border ${darkMode ? 'text-white bg-darkMainColor border-neutral-700' : 'text-black bg-white'} rounded-lg`}>
        
                                    {/*HEADER*/}
                                    <div className="w-full flex flex-row pl-3 pr-3">
        
                                        <div className={`w-full flex flex-row border-b-2 ${darkMode ? 'border-darkBgColor' : ''}`}>
        
                                            {/*Buttons Delete*/}
                                            <div className="flex flex-col items-center mr-3">
                                                {/*<Button*/}
                                                {/*    onClick={() => {*/}
                                                {/*        const newListView = !listView;*/}
                                                {/*        setListView(newListView);*/}
                                                {/*        localStorage.setItem('listViewPreference', JSON.stringify(newListView));*/}
                                                {/*      }}*/}
                                                {/*    className="rounded-full mt-auto mb-auto h-8 w-8 flex items-center justify-center align-middle">*/}
                                                {/*    {listView ? <RectangleGroupIcon className="size-5 m-auto"/> : <QueueListIcon className="size-5 m-auto"/>}*/}
                                                {/*</Button>*/}
                                            </div>
        
                                            {/*Contact Name*/}
                                            <div className="w-1/4 mr-1.5 flex flex-row items-center h-full mt-auto mb-auto">
        
                                                <div className="justify-center flex flex-col h-full">
                                                    <div className="text-sm font-semibold">Sales Rep</div>
                                                </div>
        
                                            </div>
        
                                            {/*Contact Phone*/}
                                            <div className="w-1/4 flex flex-row items-center h-full mt-auto mb-auto">
        
                                                <div className="justify-center flex flex-col h-full">
                                                    <div className="text-sm font-semibold">Customer</div>
                                                </div>
        
        
                                            </div>
        
                                            <div className="flex w-1/6 items-center justify-center h-full text-sm font-semibold">ERP</div>
        
                                            {/**/}
                                            <div className="w-1/2 ml-5 flex flex-row h-full mt-auto mb-auto items-center justify-center">
        
                                                {/*Status*/}
                                                <div className="w-1/3 ml-5 flex flex-row h-full mt-auto items-center justify-center mb-auto">
        
                                                    <div className="w-fit p-1 h-8 rounded-full flex flex-row">
                                                        <div className="flex items-center text-center justify-center h-full text-sm font-semibold">Status</div>
                                                    </div>
        
                                                </div>
        
                                                <div className="w-1/3 p-1 h-8 items-center justify-center">
                                                    {status === "Planned" ? (
                                                        <div className="flex items-center text-center justify-center h-full text-sm font-semibold">Submit to Plant</div>
                                                    ) : (
                                                        <div className={`flex items-center justify-center h-full`}>
                                                            <div className="flex items-center h-full text-sm font-semibold">Dates</div>
                                                            <Button className="rounded-full mt-auto mb-auto h-full w-8 items-center justify-center align-middle"
                                                                // onClick={toggleDateAscDesc}
                                                            >
                                                                {/*<ArrowDownIcon className={`${DateAscDesc ? '' : 'rotate-180'} transition-all duration-1000 h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto`}/>*/}
        
                                                                {/*{DateAscDesc ? (*/}
                                                                {/*    <ArrowDownIcon className="h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto"/>*/}
                                                                {/*) : (*/}
                                                                {/*    <ArrowUpIcon className="h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto"/>*/}
                                                                {/*)}*/}
                                                            </Button>
                                                        </div>
                                                    )}
                                                </div>
        
                                                <div className="w-1/3 h-8 items-center justify-center flex">
                                                    <div className="flex items-center text-center justify-center h-full text-sm font-semibold">Order Total</div>
                                                    <Button
                                                        className="rounded-full mt-auto mb-auto h-8 w-8 items-center justify-center align-middle"
                                                        // onClick={toggleAscDesc}
                                                    >
        
                                                        {/*{AscDesc ? (*/}
                                                        {/*    <ArrowDownIcon className="h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto"/>*/}
                                                        {/*) : (*/}
                                                        {/*    <ArrowUpIcon className="h-4 stroke-2 text-borderColor hover:text-bgLightGreen hover:stroke-2 hover:animate-pulse hover:scale-110 m-auto"/>*/}
                                                        {/*)}*/}
                                                    </Button>
                                                </div>
        
        
                                            </div>
        
        
                                            {/*Buttons DropDown*/}
                                            <div className="flex flex-col items-center ml-3">
                                                <div className=" mt-auto mb-auto h-8 w-8 items-center justify-center align-middle">
                                                    <TrashIcon className="h-6 text-transparent m-auto"/>
                                                </div>
                                            </div>
        
        
                                        </div>
        
                                    </div>
        
                                    {/*Orders MAP*/}
                                    <div className={`overflow-y-auto h-full ${darkMode ? 'text-white bg-darkMainColor' : 'text-black bg-white'} p-1 rounded-lg max-h-[calc(100dvh-14.5rem)] scrollbar-hide`}>
                                        
                                        <div>
                                            
                                            {filteredResults.length === 0 ? (
                                                <div className="absolute flex w-full h-full justify-center items-center">
                                                    <div
                                                        className={`flex items-center border-2 border-dashed ${darkMode ? "text-white border-borderColor" : "text-black bg-neutral-50"} w-fit px-24 py-6 h-fit mr-auto ml-auto justify-center rounded-lg hover:scale-105`}>
                                                        <div className="text-center flex items-center flex-col">
                                                            <DocumentCurrencyDollarIcon
                                                                className={`size-12 stroke-1 text-white`}/>
                                                            <h3 className="mt-2 text-sm font-semibold">No Products</h3>
                                                            <p className="mt-1 text-sm">Get started by creating a new
                                                                product.</p>
                                                            <div className="mt-6">
                                                                <Button
                                                                    type="button"
                                                                    // onClick={toggleVisibility}
                                                                    className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50"
                                                                >
                                                                    <PlusIcon aria-hidden="true"
                                                                              className="-ml-0.5 mr-1.5 size-5"/>
                                                                    New Product
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 gap-3 auto-rows-auto">
                                                        {currentResults.map((test, index) => (
                                                            <SoilCard index={index} key={test.id}
                                                                      test={test}/>
                                                        ))}
                                                    </div>
                                                    <nav
                                                        aria-label="Pagination"
                                                        className={`flex items-center justify-between border rounded-lg ${darkMode ? 'bg-darkMainColor border-neutral-700' : 'bg-white border-gray-200'} mt-3 px-4 py-1 sm:px-6`}
                                                    >
                                                        <div className="flex items-center space-x-3">
                                                            <p className="text-sm">
                                                                Showing <span
                                                                className="font-medium">{startIndex + 1}</span> to <span
                                                                className="font-medium">{Math.min(startIndex + itemsPerPage, filteredResults.length)}</span> of{' '}
                                                                <span
                                                                    className="font-medium">{filteredResults.length}</span> results
                                                            </p>
                                                            <select
                                                                value={itemsPerPage}
                                                                onChange={(e) => {
                                                                    setItemsPerPage(Number(e.target.value));
                                                                    setCurrentPage(1);
                                                                }}
                                                                className={`border rounded-lg p-1 ${darkMode ? "bg-darkMainColor border-neutral-700" : ""}`}
                                                            >
                                                                <option value={25}>25</option>
                                                                <option value={50}>50</option>
                                                                <option value={75}>75</option>
                                                                <option value={100}>100</option>
                                                            </select>
                                                        </div>
                                                        <div className="flex flex-1 justify-between sm:justify-end">
                                                            <Button
                                                                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                                                disabled={currentPage === 1}
                                                                className={`px-3 py-1 h-fit rounded-md ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "bg-green-600 text-white"}`}
                                                            >
                                                                Previous
                                                            </Button>
                                                            <Button
                                                                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                                                disabled={currentPage === totalPages}
                                                                className={`px-3 py-1 h-fit ml-3 rounded-md ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "bg-green-600 text-white"}`}
                                                            >
                                                                Next
                                                            </Button>
                                                        </div>
                                                    </nav>
                                                </>
                                            )}
                                        
                                        </div>
                                    
                                    </div>
                                
                                
                                </div>
                            
                            
                            </div>
                        
                        </div>
                    
                    
                    </div>
            
            
            </div>
    )
};


export default Soil;
